var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{class:{
    stripe: _vm.isStriped,
    highlight: _vm.isHighlighted,
    centered: _vm.isCentered,
    'responsive-table': _vm.isResponsive
  },attrs:{"id":_vm.id}},[_c('thead',[_vm._t("head",[_c('BaseTableRow',_vm._b({},'BaseTableRow',_vm.head,false))])],2),_c('tbody',[_vm._t("body",_vm._l((_vm.body),function(item,index){return _c('BaseTableRow',{key:index,attrs:{"columns":item}})}))],2)])}
var staticRenderFns = []

export { render, staticRenderFns }